const storage = "user";

export const getTokenFromStorage = () => {
  const token = localStorage.getItem(storage);
  if (!token) return null;
  return JSON.parse(token);
};

export const setLocalStorageToken = (token) =>
  localStorage.setItem(storage, JSON.stringify(token));

export const removeTokenFromLocalStorage = () =>
  localStorage.removeItem(storage);
